import * as React from "react";
import { DragSource, DragSourceSpec } from "react-dnd";

import { CustomCSS } from "@connect/Interfaces";
import AdminActivityTable from "Components/Admin/AdminActivityTable";
import { Card, Icon, Link } from "Components/Global/Common";
import { WIDGET_COLORS } from "Components/Global/Constants";
import { WIDGET_TYPES } from "Data/Objects/Widgets";

const styles = {
	cardWrapper: {
		position: "relative",
		zIndex: 15
	},
	dragging: {
		opacity: 0.4,
		zIndex: 25
	},
	header: {
		paddingLeft: 8
	},
	link: {
		background: "#FFF",
		bottom: 0,
		left: 0,
		marginTop: 10,
		padding: "3px 0",
		position: "absolute",
		textAlign: "center",
		width: "100%"
	}
} as CustomCSS;

const { name } = WIDGET_TYPES.USER_ACTIVITY;

interface IActivityWidgetProps {
	connectDragPreview?: Function;
	connectDragSource?: Function;
	isDragging?: boolean;
	onDelete: () => void;
}

interface IActivityWidgetDragObject {
	icon: string;
	type: string;
}

const cardSource: DragSourceSpec<IActivityWidgetProps, IActivityWidgetDragObject> = {
	beginDrag(props: IActivityWidgetProps): IActivityWidgetDragObject {
		return {
			icon: "lock",
			type: name
		};
	}
};

class AdminActivityWidget extends React.Component<IActivityWidgetProps> {
	constructor(props: IActivityWidgetProps) {
		super(props);
	}

	render() {
		const { connectDragSource, isDragging, onDelete } = this.props;
		const style = {
			...styles.cardWrapper,
			...(isDragging ? styles.dragging : null)
		};
		const content = (
			<div style={style}>
				<Card
					onClose={ onDelete }
					header={ this.renderHeader() }
					height={ 382 }
					color={ WIDGET_COLORS.admin }>
					<AdminActivityTable />
					<div style={ styles.link }>
						<Link to={"/admin/activity"}>View All</Link>
					</div>
				</Card>
			</div>
		);

		if (connectDragSource) {
			return connectDragSource(content);
		}

		return content;
	}

	renderHeader() {
		const { connectDragPreview } = this.props;
		const preview = (
			<h2 style={ styles.header }>
				<Icon iconWeight="regular" name="lock" /> { name }
			</h2>
		);

		if (connectDragPreview) {
			return connectDragPreview(preview, { captureDraggingState: true });
		}

		return preview;
	}
}

export default DragSource("Widget", cardSource, (connect, monitor) => ({
	connectDragPreview: connect.dragPreview(),
	connectDragSource: connect.dragSource(),
	isDragging: monitor.isDragging()
}))(AdminActivityWidget);